import type { FC, ReactNode } from 'react';
import React from 'react';
import { cn } from '../../utils/ui';
import Tooltip, { type TooltipProps } from '../Tooltip/Tooltip';

export interface HelpTipProps {
    className?: string;
    text?: string;
    children?: ReactNode;
    tooltipPosition?: TooltipProps['position'];
}

const HelpTip: FC<HelpTipProps> = props => {
    const { children, className } = props;

    function getBaseClassName() {
        return cn('text-xs cursor-pointer');
    }

    function renderIcon() {
        return (
            <svg
                className="text-base w-[1em] h-[1em]"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1}
                aria-label="Help information"
            >
                <path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0" />
                <path d="M12 9h.01" />
                <path d="M11 12h1v4h1" />
            </svg>
        );
    }

    function renderTooltip() {
        const { text, tooltipPosition } = props;
        return (
            <Tooltip position={tooltipPosition} className={cn(getBaseClassName(), className)} content={children || text} contentClassName="max-w-[250px]">
                {renderIcon()}
            </Tooltip>
        );
    }

    return renderTooltip();
};

export default HelpTip;
